import { render, staticRenderFns } from "./KozHubVideos.vue?vue&type=template&id=86a52e3e&scoped=true&"
import script from "./KozHubVideos.vue?vue&type=script&lang=js&"
export * from "./KozHubVideos.vue?vue&type=script&lang=js&"
import style0 from "./KozHubVideos.vue?vue&type=style&index=0&id=86a52e3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a52e3e",
  null
  
)

export default component.exports